import { createFileRoute } from '@tanstack/react-router';
import { RateDetailPage } from '../../features/rates';

export const Route = createFileRoute('/portal/rates/$id')({ component: RateDetailPage });
